export const container = {
  marginTop: 60,
  paddingLeft: 250,
  pointerEvents: 'all',
}
